import * as Blockly from 'blockly-tradais';
import { AtlasFieldBridge } from './atlas-field-bridge';
import { javascriptGenerator } from 'blockly-tradais/javascript';

// On-attach same-entity guard: MOVED to the component (2026-07-10) as `installEntityGuard`, exposed via
// `AtlasFieldBridge.attachEntityGuard`, so all the guard logic lives in one place and no helper owns it /
// imports another helper. Block inits now call `AtlasFieldBridge.attachEntityGuard(this)`. Original kept
// below, commented, per the no-delete rule.
// export function attachEntityGuard(block: any) {
//   block.setOnChange(function (event: any) {
//     try {
//       if (!block || block.isInFlyout || !block.workspace) return;
//       const T: any = (Blockly as any).Events;
//       const relevant = !!event && (
//         event.type === T.FINISHED_LOADING ||
//         (event.type === T.BLOCK_MOVE && event.newParentId === block.id)
//       );
//       if (!relevant) return;
//       AtlasFieldBridge.validateEntityChild && AtlasFieldBridge.validateEntityChild(block);
//     } catch { /* never throw into Blockly's change loop */ }
//   });
// }

export const EntityVariableFns = {
      customBlockForSetEntityVariable() {
        Blockly.Blocks['set_entity_variable'] = {
          init: function () {
            this.appendValueInput('VALUE')
              .setCheck('ENTITY')
              .appendField('set entity')
              .appendField(
                new NonEditableFieldVariable(
                  'NAN_ENTITY_VARIABLE',
                  undefined,
                  ['ENTITY_VARIABLE'],
                  'ENTITY_VARIABLE'
                ),
                'VAR'
              )
              .appendField('to');
            this.setPreviousStatement(true, null);
            this.setNextStatement(true, null);
            this.setColour('#745ba5');
            this.setTooltip('Set a Entity value to a variable');
            this.setHelpUrl('');
            AtlasFieldBridge.attachEntityGuard && AtlasFieldBridge.attachEntityGuard(this); // on-attach same-entity guard (unplug wrong-entity child)
          },
        };
    
        (javascriptGenerator as any).forBlock['set_entity_variable'] = function (
          block: any
        ) {
          var variableName = (javascriptGenerator as any).nameDB_.getName(
            block.getFieldValue('VAR'),
            'VARIABLE'
          );
          var value =
            (javascriptGenerator as any).valueToCode(
              block,
              'VALUE',
              (javascriptGenerator as any).ORDER_ASSIGNMENT
            ) || 'NAN';
          // var value ='';
          var inputConnection = block.getInput('VALUE').connection;
          var childBlock = inputConnection && inputConnection.targetBlock();
          var code = '';
          if(childBlock && value !== 'NAN_ENTITY_VARIABLE' && value !== 'NAN' && value !== '' &&
            variableName !== 'NAN_ENTITY_VARIABLE' && variableName !== '') {
    
    
        if(variableName.includes('globalVariable$') || variableName.includes('localVariable$') ) {
                variableName = variableName + '.data';
              }
    
          if (
                  childBlock.type == 'get_entity_variable'
          ) {     
              if(value.includes('globalVariable$') || value.includes('localVariable$') ) {
                value = value + '.data';
              }
    
            code = variableName + ' =' + value + ' ;\n';
          }
            //! set_entity_variable_by_index_of_entity_list  might have to adjust for global_variable% 
          if (
    
            childBlock.type == 'set_entity_variable_by_index_of_entity_list'
          ) {
            code =
              'if(' + value + ') {' + variableName + ' =' + value + ' ;}\n';
          }
    
          if( childBlock.type == 'get_function_entity_at_index') {
           code =  variableName + ' = ' + value + ';\n';     }
    
          code = ' await this.reinitializeComponents(); ' + code;
          }
          return code;
        };
    
        class NonEditableFieldVariable extends Blockly.FieldVariable {
          constructor(
            variableName: any,
            validator: any,
            variableTypes: any,
            defaultType: any
          ) {
            super(variableName, validator, variableTypes, defaultType);
          }
    
          // Override the showEditor_ method to disable editing
          override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
        }
      } ,
       customBlockForGetEntityVariable() {
          Blockly.Blocks['get_entity_variable'] = {
            init: function () {
              this.appendDummyInput('VALUE')
                .appendField('get entity')
                .appendField(
                  new NonEditableFieldVariable(
                    'NAN_ENTITY_VARIABLE',
                    undefined,
                    ['ENTITY_VARIABLE'],
                    'ENTITY_VARIABLE'
                  ),
                  'VAR'
                );
              // .appendField(new Blockly.FieldVariable('_0_', undefined , ['Boolean'], 'Boolean'), 'VAR')
              // .appendField(new Blockly.FieldLabel('localVariable$defaultFlag'), 'VAR')
              // .appendField('to');
              this.setOutput(true, 'ENTITY');
              // this.setPreviousStatement(true, null);
              // this.setNextStatement(true, null);
              this.setColour('#745ba5');
              this.setTooltip('Set a Entity value to a variable');
              this.setHelpUrl('');
            },
          };
      
          (javascriptGenerator as any).forBlock['get_entity_variable'] = function (
            block: any
          ) {
            var variableName = (javascriptGenerator as any).nameDB_.getName(
              block.getFieldValue('VAR'),
              'VARIABLE'
            );
            // var value = (javascriptGenerator as any).valueToCode(block, 'VALUE', (javascriptGenerator as any).ORDER_ASSIGNMENT) || '[]';
            if (variableName !== 'NAN')
              return [variableName, (javascriptGenerator as any).ORDER_ATOMIC];
      
            return ['', (javascriptGenerator as any).ORDER_ATOMIC];
            // return variableName + ' =' + value + ';\n';
          };
      
          class NonEditableFieldVariable extends Blockly.FieldVariable {
            constructor(
              variableName: any,
              validator: any,
              variableTypes: any,
              defaultType: any
            ) {
              super(variableName, validator, variableTypes, defaultType);
            }
      
            // Override the showEditor_ method to disable editing
            override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
          }
        } ,
         customBlockForSetEntityFromEntityListVariable() {
            Blockly.Blocks['set_entity_variable_by_index_of_entity_list'] = {
              init: function () {
                this.appendValueInput('VALUE')
                  .setCheck('Array')
                  // .appendField('set entity')
                  // .appendField(new NonEditableFieldVariable('NAN', undefined, ['ENTITY_VARIABLE'], 'ENTITY_VARIABLE'), 'VAR')
                  .appendField('to');
                this.appendValueInput('INDEX').setCheck('Number').appendField('#');
        
                this.setInputsInline(true);
                this.setOutput(true, 'ENTITY');
                // this.setPreviousStatement(true, null);
                this.setColour('#745ba5');
                this.setTooltip('Set a Entity value to a variable');
                this.setHelpUrl('');
              },
            };
        
            (javascriptGenerator as any).forBlock[
              'set_entity_variable_by_index_of_entity_list'
            ] = function (block: any) {
              // var variableName = (javascriptGenerator as any).nameDB_.getName(
              //   block.getFieldValue('VAR'), 'VARIABLE');
              var value =
                (javascriptGenerator as any).valueToCode(
                  block,
                  'VALUE',
                  (javascriptGenerator as any).ORDER_ASSIGNMENT
                ) || '';
              var valueIndex =
                (javascriptGenerator as any).valueToCode(
                  block,
                  'INDEX',
                  (javascriptGenerator as any).ORDER_ASSIGNMENT
                ) || '0';
              if (value !== '')
                return [
                  value + '[' + valueIndex + ']',
                  (javascriptGenerator as any).ORDER_ATOMIC,
                ];
        
              return ['', (javascriptGenerator as any).ORDER_ATOMIC];
            };
        
            class NonEditableFieldVariable extends Blockly.FieldVariable {
              constructor(
                variableName: any,
                validator: any,
                variableTypes: any,
                defaultType: any
              ) {
                super(variableName, validator, variableTypes, defaultType);
              }
        
              // Override the showEditor_ method to disable editing
              override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
            }
          } ,
         customBlockForSetReferenceEntityVariableFromArrayObjects() {
            Blockly.Blocks['set_reference_entity_variable_for_AOB'] = {
              init: function () {
                this.appendValueInput('VALUE')
                  .setCheck(['ENTITY' , 'REFERENCE_ENTITY_VARIABLE_AOB'])
                  .appendField('set reference entity for AOB')
                  .appendField(
                    new NonEditableFieldVariable(
                      'NAN_ENTITY_VARIABLE',
                      undefined,
                      ['ENTITY_VARIABLE', 'REFERENCE_ENTITY_VARIABLE_AOB'],
                      'ENTITY_VARIABLE'
                    ),
                    'VAR'
                  )
                  .appendField('to');
                this.setPreviousStatement(true, null);
                this.setNextStatement(true, null);
                this.setColour('#89F336');
                this.setTooltip('Set a reference Entity value to a variable');
                this.setHelpUrl('');
                AtlasFieldBridge.attachEntityGuard && AtlasFieldBridge.attachEntityGuard(this); // #10: on-attach same-entity guard (was wired only to the two entity setters)
              },
            };

            (javascriptGenerator as any).forBlock['set_reference_entity_variable_for_AOB'] = function (
              block: any
            ) {
              var variableName = (javascriptGenerator as any).nameDB_.getName(
                block.getFieldValue('VAR'),
                'VARIABLE'
              );
              var value =
                (javascriptGenerator as any).valueToCode(
                  block,
                  'VALUE',
                  (javascriptGenerator as any).ORDER_ASSIGNMENT
                ) || 'NAN';
              // var value ='';
              var inputConnection = block.getInput('VALUE').connection;
              var childBlock = inputConnection && inputConnection.targetBlock();
              var code = '';
              if(childBlock) {
              // if (
              //   value !== 'NAN' &&
              //   variableName !== 'NAN_ENTITY_VARIABLE' &&
              //   childBlock.type == 'get_entity_variable'
              // )
              //   code = variableName + '$ =' + value + '.data ;\n';
              if (
                variableName !== 'NAN_ENTITY_VARIABLE' &&
                value !== 'NAN' &&
                (childBlock.type == 'set_entity_variable_by_index_of_entity_list' || childBlock.type == 'get_reference_entity_variable_for_AOB_reference_AOB')
              ) {
                var valueChangedForAOBReference = value;
                if(value.includes('entity_reference_for_AOB$')) {
                //  valueChangedForAOBReference = value.replace(/(?<!\$)\[/g, '$[');
                valueChangedForAOBReference = value.replace(
                          /(?<=entity_reference_for_AOB\$[^$]*)\[/g,
                          '$['
                        );
                }
                code =
                  'if(' + valueChangedForAOBReference + ') {' + variableName + '$ =' + valueChangedForAOBReference + ';}\n';
               }
                // else {
                // alert('something went wrong - set_reference_entity_variable_for_AOB ')
                //   }
              // if(value !== 'NAN' && variableName !== 'NAN_ENTITY_VARIABLE' && childBlock.type == 'get_function_entity_at_index') {
              //  code =  variableName + '$ = ' + value + ';\n';     }
        
              // code = ' await this.reinitializeComponents(); ' + code;
              }
        
              return code;
            };
        
            class NonEditableFieldVariable extends Blockly.FieldVariable {
              constructor(
                variableName: any,
                validator: any,
                variableTypes: any,
                defaultType: any
              ) {
                super(variableName, validator, variableTypes, defaultType);
              }
        
              // Override the showEditor_ method to disable editing
              override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
            }
          } ,
            customBlockForGetReferenceEntityVariableFromArrayObjectsVariableReferenceOfAOB() {
              Blockly.Blocks['get_reference_entity_variable_for_AOB_reference_AOB'] = {
                init: function () {   
                  
                  this.appendDummyInput()
                    .appendField('get reference in AOB FROM AOB reference')
                    .appendField(
                      new NonEditableFieldVariable(
                        'NAN',
                        undefined,
                        ['REFERENCE_ENTITY_VARIABLE_AOB'],
                        'REFERENCE_ENTITY_VARIABLE_AOB'
                      ),
                      'VAR'
                    );
                            this.appendValueInput('VALUE')
                    .setCheck(['Number']) .appendField(' - Index :')
          
                  this.setOutput(true, 'REFERENCE_ENTITY_VARIABLE_AOB');
                
                  // this.setPreviousStatement(true, null);
                  // this.setNextStatement(true, null);
                  this.setColour('#89F336');
                  this.setTooltip('get reference in AOB FROM AOB reference');
                  this.setHelpUrl('');
                },
              };
          
              (javascriptGenerator as any).forBlock['get_reference_entity_variable_for_AOB_reference_AOB'] = function (
                block: any
              ) {
          
                      var variableName = (javascriptGenerator as any).nameDB_.getName(
                  block.getFieldValue('VAR'),
                  'VARIABLE'
                );
                     var value =
                  (javascriptGenerator as any).valueToCode(
                    block,
                    'VALUE',
                    (javascriptGenerator as any).ORDER_ASSIGNMENT
                  ) || 0;
          
                return [variableName + '[' +  value + ']', (javascriptGenerator as any).ORDER_ATOMIC];
              };
          
              class NonEditableFieldVariable extends Blockly.FieldVariable {
                constructor(
                  variableName: any,
                  validator: any,
                  variableTypes: any,
                  defaultType: any
                ) {
                  super(variableName, validator, variableTypes, defaultType);
                }
          
                // Override the showEditor_ method to disable editing
                override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
              }
            } ,
              customBlockForSetKeyValueInAobReference() {
                // REDESIGNED 2026-06-29: was a reference-pointer field-writer — it set systemKey/
                // systemType/system<Type> on whatever single AOB row a REFERENCE_ENTITY_VARIABLE_AOB
                // pointed at (a no-lookup overwrite; 0 uses in the corpus, see ANALYSIS.md). Now an
                // AAOB key/value UPSERT: pick the AAOB by entity + AAOB field via a two-step dropdown
                // (same selection as aaob_aggregate_by_label — no getter to plug in), give key + type +
                // value; it matches on (systemKey, systemType) → edits that row's value column, else
                // pushes a new six-column row. In-place mutation OK'd by owner (the block was never used).
                // Runtime: ui-editor.component.ts upsertAaobKeyValue() via getVariableByMultiData(entity,
                // aaobField). The block id stays 'set_key_value_in_AOB_reference' for registration continuity.
                class AaobHelpField extends Blockly.FieldTextInput {
                  legendText: any;
                  override showEditor_() { try { (window as any).alert((this as any).legendText || ''); } catch { /* no-op */ } }
                }
                const makeAaobHelp = (): any => {
                  const f: any = new AaobHelpField('ⓘ');
                  f.legendText =
                    'Set value for key in AAOB — match is on (key + type):\n' +
                    '• same key + same type already present → edits that row’s value\n' +
                    '• same key with a different type → kept as a separate row\n' +
                    '• not present → adds a new row';
                  return f;
                };
                Blockly.Blocks['set_key_value_in_AOB_reference'] = {
                  init: function () {
                    // target: pick entity + AAOB field via the two-step AAOB picker (same selection as
                    // aaob_aggregate_by_label) — clicking either dropdown opens Atlas (AAOB_UPSERT).
                    this.appendDummyInput()
                      .appendField('set value for key in AAOB')
                      .appendField(makeAaobHelp(), 'AAOB_INFO');
                    this.appendDummyInput()
                      .appendField('entity')
                      .appendField(
                        new NonEditableFieldVariable('NANENTITY', undefined, ['ENTITYNAME'], 'ENTITYNAME'),
                        'VAR'
                      );
                    this.appendDummyInput()
                      .appendField('AAOB')
                      .appendField(
                        new NonEditableFieldVariable('NANAAOB_FIELD', undefined, ['AAOB_FIELD'], 'AAOB_FIELD'),
                        'AAOB_FIELD'
                      );

                    this.appendValueInput('KEY')
                      .setCheck(['String'])
                      .appendField('key');

                    this.appendDummyInput('TYPE_INPUT')
                      .appendField('type')
                      .appendField(
                        new Blockly.FieldDropdown(
                          [
                            ['String', 'String'],
                            // AAOB restricted to String for now (2026-06-29) — unlock later (kept here +
                            // in AAOB_VALUE_TYPES in condition-targets.ts). Uncomment to re-enable:
                            // ['Number', 'Number'],
                            // ['Boolean', 'Boolean'],
                            // ['TimeStamp', 'TimeStamp'],
                          ],
                          function (this: any, newValue: any) {
                            const sourceBlock = this.getSourceBlock?.();
                            if (sourceBlock?.getInput?.('VALUE')) {
                              sourceBlock.getInput('VALUE').setCheck([newValue]);
                            }
                            return newValue;
                          }
                        ),
                        'TYPE'
                      );

                    this.appendValueInput('VALUE')
                      .setCheck(['String'])
                      .appendField('value');

                    this.setInputsInline(false); // multi-field block — one row per input
                    this.setPreviousStatement(true, null);
                    this.setNextStatement(true, null);
                    this.setColour('#2EAF9E'); // AAOB key/value — teal-green, distinct from the lime AOB blocks (#89F336)
                    this.setTooltip('Upsert a key/value into an AAOB (extendedAttributes) list — matches on (key,type): edits that row, else adds one');
                    this.setHelpUrl('');
                    // save/reload: re-apply VALUE's socket check from TYPE AFTER load (never during
                    // deserialization) — same pattern as the value-carrying push block.
                    const blk: any = this;
                    this.setOnChange(function (e: any) {
                      if (!blk.workspace || blk.isInFlyout || !e) return;
                      if (e.type === (Blockly as any).Events.FINISHED_LOADING) {
                        const inp = blk.getInput('VALUE');
                        if (inp) inp.setCheck([blk.getFieldValue('TYPE')]);
                      }
                    });
                  },
                };

                (javascriptGenerator as any).forBlock['set_key_value_in_AOB_reference'] = function (
                  block: any
                ) {
                  // target = entity (VAR) + AAOB field (AAOB_FIELD), picked via the two-step AAOB
                  // picker (mirrors aaob_aggregate_by_label).
                  var entity = block.getFieldValue('VAR');
                  var rawAaob = block.getFieldValue('AAOB_FIELD') || '';
                  var entityVariable = rawAaob === 'NANAAOB_FIELD' ? '' : rawAaob;

                  var key =
                    (javascriptGenerator as any).valueToCode(
                      block,
                      'KEY',
                      (javascriptGenerator as any).ORDER_NONE
                    ) || "''";

                  var value =
                    (javascriptGenerator as any).valueToCode(
                      block,
                      'VALUE',
                      (javascriptGenerator as any).ORDER_ASSIGNMENT
                    ) || "''";

                  var selectedType = block.getFieldValue('TYPE');
                  if (selectedType === 'String' || selectedType === 'TimeStamp') {
                    value = "'' + " + value; // coerce to string for the String/TimeStamp value slots
                  }

                  var code = '';
                  if (entity && entity !== '' && entity !== 'NANENTITY' && entityVariable && entityVariable !== '') {
                    // upsert by (systemKey, systemType) into the resolved AAOB .data —
                    // see ui-editor.component.ts upsertAaobKeyValue()
                    code =
                      'this.upsertAaobKeyValue(\'' + entity + '\', \'' + entityVariable + '\', ' +
                      key + ', \'' + selectedType + '\', ' + value + ');\n';
                  }
                  code += 'this.reinitializeComponantsFlag = true;\n this.scrollPositionsFlag = true;\n';
                  return code;
                };

                class NonEditableFieldVariable extends Blockly.FieldVariable {
                  constructor(
                    variableName: any,
                    validator: any,
                    variableTypes: any,
                    defaultType: any
                  ) {
                    super(variableName, validator, variableTypes, defaultType);
                  }

                  // Override the showEditor_ method to disable editing
                  override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                }
              } ,
                customBlockForSetReferenceEntityVariableFromArrayObjectsVariableString() {
                Blockly.Blocks['set_reference_entity_variable_for_AOB_variable_string'] = {
                  init: function () {   
                    
                            this.appendValueInput('VALUE')
                      .setCheck(['String', 'Number'])
                      .appendField('set String FROM AOB reference')
                      .appendField(
                        new NonEditableFieldVariable(
                          'NAN',
                          undefined,
                          ['String', 'Number'],
                          'String'
                        ),
                        'VAR'
                      )
                      .appendField('to');
                    this.setPreviousStatement(true, null);
                    this.setNextStatement(true, null);
                    this.setColour('#5ba58c');
                    this.setTooltip('Set a string value to a variable');
                    this.setHelpUrl('');
            
                  },
                };
            
                (javascriptGenerator as any).forBlock['set_reference_entity_variable_for_AOB_variable_string'] = function (
                  block: any
                ) {
            
                        var variableName = (javascriptGenerator as any).nameDB_.getName(
                    block.getFieldValue('VAR'),
                    'VARIABLE'
                  );
                  var value =
                    (javascriptGenerator as any).valueToCode(
                      block,
                      'VALUE',
                      (javascriptGenerator as any).ORDER_ASSIGNMENT
                    ) || '0';
            
                  return variableName + " =  '' + " + value + ';\n';
                };
            
                class NonEditableFieldVariable extends Blockly.FieldVariable {
                  constructor(
                    variableName: any,
                    validator: any,
                    variableTypes: any,
                    defaultType: any
                  ) {
                    super(variableName, validator, variableTypes, defaultType);
                  }
            
                  // Override the showEditor_ method to disable editing
                  override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                }
              }
            ,
              customBlockForGetReferenceEntityVariableFromArrayObjectsVariableString() {
                Blockly.Blocks['get_reference_entity_variable_for_AOB_variable_string'] = {
                  init: function () {   
                    
                    this.appendDummyInput()
                      .appendField('get string FROM AOB reference')
                      .appendField(
                        new NonEditableFieldVariable(
                          'NAN',
                          undefined,
                          ['String', 'Number'],
                          'String'
                        ),
                        'VAR'
                      );
            
                    this.setOutput(true, 'String');
                  
                    // this.setPreviousStatement(true, null);
                    // this.setNextStatement(true, null);
                    this.setColour('#5ba58c');
                    this.setTooltip('get string FROM AOB reference');
                    this.setHelpUrl('');
                  },
                };
            
                (javascriptGenerator as any).forBlock['get_reference_entity_variable_for_AOB_variable_string'] = function (
                  block: any
                ) {
            
                        var variableName = (javascriptGenerator as any).nameDB_.getName(
                    block.getFieldValue('VAR'),
                    'VARIABLE'
                  );
            
                  return [variableName, (javascriptGenerator as any).ORDER_ATOMIC];
                };
            
                class NonEditableFieldVariable extends Blockly.FieldVariable {
                  constructor(
                    variableName: any,
                    validator: any,
                    variableTypes: any,
                    defaultType: any
                  ) {
                    super(variableName, validator, variableTypes, defaultType);
                  }
            
                  // Override the showEditor_ method to disable editing
                  override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                }
              } ,    customBlockForSetReferenceEntityVariableFromArrayObjectsVariableTimeStamp() {
                Blockly.Blocks['set_reference_entity_variable_for_AOB_variable_time_stamp'] = {
                  init: function () {   
                    
                            this.appendValueInput('VALUE')
                      .setCheck(['TimeStamp'])
                      .appendField('set Time Stamp FROM AOB reference')
                      .appendField(
                        new NonEditableFieldVariable(
                          'NAN',
                          undefined,
                          ['TimeStamp'],
                          'TimeStamp'
                        ),
                        'VAR'
                      )
                      .appendField('to');
                    this.setPreviousStatement(true, null);
                    this.setNextStatement(true, null);
                    this.setColour('#F5A623');
                    this.setTooltip('Set a TimeStamp value to a variable');
                    this.setHelpUrl('');
            
                  },
                };
            
                (javascriptGenerator as any).forBlock['set_reference_entity_variable_for_AOB_variable_time_stamp'] = function (
                  block: any
                ) {
            
                        var variableName = (javascriptGenerator as any).nameDB_.getName(
                    block.getFieldValue('VAR'),
                    'VARIABLE'
                  );
                  var value =
                    (javascriptGenerator as any).valueToCode(
                      block,
                      'VALUE',
                      (javascriptGenerator as any).ORDER_ASSIGNMENT
                    ) || '0';
            
                  return variableName + " =  '' + " + value + ';\n';
                };
            
                class NonEditableFieldVariable extends Blockly.FieldVariable {
                  constructor(
                    variableName: any,
                    validator: any,
                    variableTypes: any,
                    defaultType: any
                  ) {
                    super(variableName, validator, variableTypes, defaultType);
                  }
            
                  // Override the showEditor_ method to disable editing
                  override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                }
              }
            ,
              customBlockForGetReferenceEntityVariableFromArrayObjectsVariableTimeStamp() {
                Blockly.Blocks['get_reference_entity_variable_for_AOB_variable_time_stamp'] = {
                  init: function () {   
                    
                    this.appendDummyInput()
                      .appendField('get Time Stamp FROM AOB reference')
                      .appendField(
                        new NonEditableFieldVariable(
                          'NAN',
                          undefined,
                          ['TimeStamp'],
                          'TimeStamp'
                        ),
                        'VAR'
                      );
            
                    this.setOutput(true, 'TimeStamp');
                  
                    // this.setPreviousStatement(true, null);
                    // this.setNextStatement(true, null);
                    this.setColour('#F5A623');
                    this.setTooltip('get Time Stamp FROM AOB reference');
                    this.setHelpUrl('');
                  },
                };
            
                (javascriptGenerator as any).forBlock['get_reference_entity_variable_for_AOB_variable_time_stamp'] = function (
                  block: any
                ) {
            
                        var variableName = (javascriptGenerator as any).nameDB_.getName(
                    block.getFieldValue('VAR'),
                    'VARIABLE'
                  );
            
                  return [variableName, (javascriptGenerator as any).ORDER_ATOMIC];
                };
            
                class NonEditableFieldVariable extends Blockly.FieldVariable {
                  constructor(
                    variableName: any,
                    validator: any,
                    variableTypes: any,
                    defaultType: any
                  ) {
                    super(variableName, validator, variableTypes, defaultType);
                  }
            
                  // Override the showEditor_ method to disable editing
                  override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                }
              } ,
                      customBlockForSetReferenceEntityVariableFromArrayObjectsVariableNumber() {
                    Blockly.Blocks['set_reference_entity_variable_for_AOB_variable_number'] = {
                      init: function () {   
                        
                                this.appendValueInput('VALUE')
                          .setCheck(['Number'])
                          .appendField('set Number FROM AOB reference')
                          .appendField(
                            new NonEditableFieldVariable(
                              'NAN',
                              undefined,
                              ['Number'],
                              'Number'
                            ),
                            'VAR'
                          )
                          .appendField('to');
                        this.setPreviousStatement(true, null);
                        this.setNextStatement(true, null);
                        this.setColour(230);
                        this.setTooltip('Set a number value to a variable');
                        this.setHelpUrl('');
                
                      },
                    };
                
                    (javascriptGenerator as any).forBlock['set_reference_entity_variable_for_AOB_variable_number'] = function (
                      block: any
                    ) {
                
                            var variableName = (javascriptGenerator as any).nameDB_.getName(
                        block.getFieldValue('VAR'),
                        'VARIABLE'
                      );
                      var value =
                        (javascriptGenerator as any).valueToCode(
                          block,
                          'VALUE',
                          (javascriptGenerator as any).ORDER_ASSIGNMENT
                        ) || '0';
                
                      return variableName + " = " + value + ';\n';
                    };
                
                    class NonEditableFieldVariable extends Blockly.FieldVariable {
                      constructor(
                        variableName: any,
                        validator: any,
                        variableTypes: any,
                        defaultType: any
                      ) {
                        super(variableName, validator, variableTypes, defaultType);
                      }
                
                      // Override the showEditor_ method to disable editing
                      override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                    }
                  } ,
                     customBlockForGetReferenceEntityVariableFromArrayObjectsVariableNumber() {
                      Blockly.Blocks['get_reference_entity_variable_for_AOB_variable_number'] = {
                        init: function () {   
                          
                          this.appendDummyInput()
                            .appendField('get number FROM AOB reference')
                            .appendField(
                              new NonEditableFieldVariable(
                                'NAN',
                                undefined,
                                [ 'Number'],
                                'Number'
                              ),
                              'VAR'
                            );
                  
                          this.setOutput(true, 'Number');
                        
                          // this.setPreviousStatement(true, null);
                          // this.setNextStatement(true, null);
                          this.setColour(230);
                          this.setTooltip('get number FROM AOB reference');
                          this.setHelpUrl('');
                        },
                      };
                  
                      (javascriptGenerator as any).forBlock['get_reference_entity_variable_for_AOB_variable_number'] = function (
                        block: any
                      ) {
                  
                              var variableName = (javascriptGenerator as any).nameDB_.getName(
                          block.getFieldValue('VAR'),
                          'VARIABLE'
                        );
                  
                        return [variableName, (javascriptGenerator as any).ORDER_ATOMIC];
                      };
                  
                      class NonEditableFieldVariable extends Blockly.FieldVariable {
                        constructor(
                          variableName: any,
                          validator: any,
                          variableTypes: any,
                          defaultType: any
                        ) {
                          super(variableName, validator, variableTypes, defaultType);
                        }
                  
                        // Override the showEditor_ method to disable editing
                        override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                      }
                    } ,
                          customBlockForSetReferenceEntityVariableFromArrayObjectsVariableBoolean() {
                        Blockly.Blocks['set_reference_entity_variable_for_AOB_variable_boolean'] = {
                          init: function () {   
                            
                                    this.appendValueInput('VALUE')
                              .setCheck(['Boolean'])
                              .appendField('set Boolean FROM AOB reference')
                              .appendField(
                                new NonEditableFieldVariable(
                                  'NAN',
                                  undefined,
                                  ['Boolean'],
                                  'Boolean'
                                ),
                                'VAR'
                              )
                              .appendField('to');
                            this.setPreviousStatement(true, null);
                            this.setNextStatement(true, null);
                            this.setColour(0);
                            this.setTooltip('Set a boolean value to a variable');
                            this.setHelpUrl('');
                    
                          },
                        };
                    
                        (javascriptGenerator as any).forBlock['set_reference_entity_variable_for_AOB_variable_boolean'] = function (
                          block: any
                        ) {
                    
                                var variableName = (javascriptGenerator as any).nameDB_.getName(
                            block.getFieldValue('VAR'),
                            'VARIABLE'
                          );
                          var value =
                            (javascriptGenerator as any).valueToCode(
                              block,
                              'VALUE',
                              (javascriptGenerator as any).ORDER_ASSIGNMENT
                            ) || '0';
                    
                          return variableName + " = " + value + ';\n';
                        };
                    
                        class NonEditableFieldVariable extends Blockly.FieldVariable {
                          constructor(
                            variableName: any,
                            validator: any,
                            variableTypes: any,
                            defaultType: any
                          ) {
                            super(variableName, validator, variableTypes, defaultType);
                          }
                    
                          // Override the showEditor_ method to disable editing
                          override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                        }
                      } ,
                           customBlockForGetReferenceEntityVariableFromArrayObjectsVariableBoolean() {
                          Blockly.Blocks['get_reference_entity_variable_for_AOB_variable_boolean'] = {
                            init: function () {   
                              
                              this.appendDummyInput()
                                .appendField('get boolean FROM AOB reference')
                                .appendField(
                                  new NonEditableFieldVariable(
                                    'NAN',
                                    undefined,
                                    [ 'Boolean'],
                                    'Boolean'
                                  ),
                                  'VAR'
                                );
                      
                              this.setOutput(true, 'Boolean');
                            
                              // this.setPreviousStatement(true, null);
                              // this.setNextStatement(true, null);
                              this.setColour(0);
                              this.setTooltip('get boolean FROM AOB reference');
                              this.setHelpUrl('');
                            },
                          };
                      
                          (javascriptGenerator as any).forBlock['get_reference_entity_variable_for_AOB_variable_boolean'] = function (
                            block: any
                          ) {
                      
                                  var variableName = (javascriptGenerator as any).nameDB_.getName(
                              block.getFieldValue('VAR'),
                              'VARIABLE'
                            );
                      
                            return [variableName, (javascriptGenerator as any).ORDER_ATOMIC];
                          };
                      
                          class NonEditableFieldVariable extends Blockly.FieldVariable {
                            constructor(
                              variableName: any,
                              validator: any,
                              variableTypes: any,
                              defaultType: any
                            ) {
                              super(variableName, validator, variableTypes, defaultType);
                            }
                      
                            // Override the showEditor_ method to disable editing
                            override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                          }
                        } ,
                          customBlockForSetEntityListVariable() {
                            Blockly.Blocks['set_entity_list_variable'] = {
                              init: function () {
                                this.appendValueInput('VALUE')
                                  .setCheck(['ENTITY_LIST', 'Array'])
                                  .appendField('set entity list')
                                  .appendField(
                                    new NonEditableFieldVariable(
                                      'NAN',
                                      undefined,
                                      ['ENTITY_LIST_VARIABLE'],
                                      'ENTITY_LIST_VARIABLE'
                                    ),
                                    'VAR'
                                  )
                                  // .appendField(new Blockly.FieldVariable('_0_', undefined , ['Boolean'], 'Boolean'), 'VAR')
                                  // .appendField(new Blockly.FieldLabel('localVariable$defaultFlag'), 'VAR')
                                  .appendField('to');
                                this.setPreviousStatement(true, null);
                                this.setNextStatement(true, null);
                                this.setColour('#000000');
                                this.setTooltip('Set a Entity value to a variable');
                                this.setHelpUrl('');
                                AtlasFieldBridge.attachEntityGuard && AtlasFieldBridge.attachEntityGuard(this); // on-attach same-entity guard (unplug wrong-entity child)
                              },
                            };
                        
                            (javascriptGenerator as any).forBlock['set_entity_list_variable'] =
                              function (block: any) {
                                var variableName = (javascriptGenerator as any).nameDB_.getName(
                                  block.getFieldValue('VAR'),
                                  'VARIABLE'
                                );
                                var value =
                                  (javascriptGenerator as any).valueToCode(
                                    block,
                                    'VALUE',
                                    (javascriptGenerator as any).ORDER_ASSIGNMENT
                                  ) || '[]';
                                // A list read from another list variable (or an Advanced list field, read through the
                                // same block) is copied so the two lists stop sharing rows; a query result is fresh and
                                // keeps its code. Only .data is replaced, so the target keeps its entity.
                                var valueBlock = block.getInputTargetBlock('VALUE');
                                if (valueBlock && valueBlock.type === 'get_entity_list_variable' && value !== '[]' && value !== '')
                                  value = 'structuredClone(' + value + ')';
                                if (variableName !== 'NAN')
                                  return (
                                    " await this.reinitializeComponents(); " +
                                    variableName +
                                    '=' +
                                    value +
                                    ';\n'
                                  );
                                //  + ' console.log(' + variableName + ');\n';
                        
                                return '';
                                // return variableName + ' =' + value + ';\n';
                              };
                        
                            class NonEditableFieldVariable extends Blockly.FieldVariable {
                              constructor(
                                variableName: any,
                                validator: any,
                                variableTypes: any,
                                defaultType: any
                              ) {
                                super(variableName, validator, variableTypes, defaultType);
                              }
                        
                              // Override the showEditor_ method to disable editing
                              override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                            }
                          } ,
                           customBlockForGetEntityListVariable() {
                              Blockly.Blocks['get_entity_list_variable'] = {
                                init: function () {
                                  this.appendDummyInput('VALUE')
                                    .appendField('get entity list')
                                    .appendField(
                                      new NonEditableFieldVariable(
                                        'NAN',
                                        undefined,
                                        // Accept reference-AOB vars too, so a push target picked from the
                                        // "Entity reference AOB fields" bucket (entity_reference_for_AOB$<refId>,
                                        // pre-registered as REFERENCE_ENTITY_VARIABLE_AOB) binds without a
                                        // type-mismatch rejection. Field is Atlas-driven (non-editable) → this
                                        // only affects programmatic setValue, not any dropdown.
                                        // AAOB_FIELD (zavo_oct_06): since bf9334e5 the registry mints Advanced (AAOB) list
                                        // fields as AAOB_FIELD, so a picked or saved AAOB list was rejected and shown as NAN.
                                        // Reading an AAOB list is legitimate; WRITE parents (push / delete / set-at-index)
                                        // keep AAOB out at the Atlas picker (excludeAaob / excludeAaobFields).
                                        // Was: ['ENTITY_LIST_VARIABLE', 'REFERENCE_ENTITY_VARIABLE_AOB'],
                                        ['ENTITY_LIST_VARIABLE', 'REFERENCE_ENTITY_VARIABLE_AOB', 'AAOB_FIELD'],
                                        'ENTITY_LIST_VARIABLE'
                                      ),
                                      'VAR'
                                    );
                                  // .appendField(new Blockly.FieldVariable('_0_', undefined , ['Boolean'], 'Boolean'), 'VAR')
                                  // .appendField(new Blockly.FieldLabel('localVariable$defaultFlag'), 'VAR')
                                  // .appendField('to');
                                  this.setOutput(true, 'Array');
                                  // this.setPreviousStatement(true, null);
                                  // this.setNextStatement(true, null);
                                  this.setColour('#000000');
                                  this.setTooltip('Set a Entity value to a variable');
                                  this.setHelpUrl('');
                                },
                              };
                          
                              (javascriptGenerator as any).forBlock['get_entity_list_variable'] =
                                function (block: any) {
                                  var variableName = (javascriptGenerator as any).nameDB_.getName(
                                    block.getFieldValue('VAR'),
                                    'VARIABLE'
                                  );
                                  // var value = (javascriptGenerator as any).valueToCode(block, 'VALUE', (javascriptGenerator as any).ORDER_ASSIGNMENT) || '[]';
                                  if (variableName !== 'NAN')
                                    return [variableName, (javascriptGenerator as any).ORDER_ATOMIC];
                          
                                  return ['', (javascriptGenerator as any).ORDER_ATOMIC];
                                  // return variableName + ' =' + value + ';\n';
                                };
                          
                              class NonEditableFieldVariable extends Blockly.FieldVariable {
                                constructor(
                                  variableName: any,
                                  validator: any,
                                  variableTypes: any,
                                  defaultType: any
                                ) {
                                  super(variableName, validator, variableTypes, defaultType);
                                }
                          
                                // Override the showEditor_ method to disable editing
                                override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                              }
                            } ,
                              customBlockForPushNewElementToArray() {
                                Blockly.Blocks['push_new_element_to_array'] = {
                                  init: function () {
                              
                                      this.appendValueInput("ARRAY_INPUT")
                                        .setCheck(["Array", "REFERENCE_ENTITY_VARIABLE_AOB"]) // Assuming "Array" is a defined type check
                                        .appendField("push to array");
                                    this.setPreviousStatement(true, null);
                                    this.setNextStatement(true, null);
                                    this.setColour('#4B0082'); // Indigo for "special" category
                                    this.setTooltip("Pushes a new element to the end of an array.");
                                    this.setHelpUrl("");
                                  }
                                };
                            
                                (javascriptGenerator as any).forBlock['push_new_element_to_array'] = function (block: any) {
                                // TODO: change the code generation for the block
                                  var arrayInput = (javascriptGenerator as any).valueToCode(
                                    block,
                                    'ARRAY_INPUT',
                                    (javascriptGenerator as any).ORDER_MEMBER
                                  ) || '[]';
                                  if(arrayInput.includes('entity_reference_for_AOB')) {
                                    arrayInput = arrayInput.replace(/\[.*?\]/g, "");
                                    arrayInput = arrayInput.replace(/\$$/, "");
                                    const dollarInsideVaraibleFlag = (arrayInput.replace('entity_reference_for_AOB$' , '')).includes('$');
                                    if(!dollarInsideVaraibleFlag)
                                  return `
                                  await this.getArrayElement(\'${arrayInput}$\');  this.reinitializeComponantsFlag = true;`;
                                  }
                                  return `
                                  await this.getArrayElement(\'${arrayInput}\');  this.reinitializeComponantsFlag = true;`;
                                };
                              } ,
                                  customBlockForGetEntityLength() {
                                    Blockly.Blocks['get_entity_length'] = {
                                      init: function () {
                                
                                        this.appendDummyInput('VALUE')
                                        .appendField('get entity length  ')
                                        .appendField(
                                          new NonEditableFieldVariable(
                                            'NAN',
                                            undefined,
                                            // AAOB_FIELD (zavo_oct_06 follow-up): an Advanced (AAOB) list field is minted as
                                            // AAOB_FIELD since bf9334e5, so its length could not be read (a builder needs it to
                                            // loop over the list). Reading a length cannot bypass the AAOB upsert.
                                            // Was: ['ENTITY_LIST_VARIABLE'],
                                            ['ENTITY_LIST_VARIABLE', 'AAOB_FIELD'],
                                            'ENTITY_LIST_VARIABLE'
                                          ),
                                          'VAR'
                                        );
                                        this.setOutput(true, 'Number');
                                        this.setInputsInline(true);
                                         this.setColour('#800000');
                                        this.setTooltip('Select function variable');
                                        this.setHelpUrl('');
                                      },
                                    };
                                
                                    (javascriptGenerator as any).forBlock['get_entity_length'] = function (
                                      block: any
                                    ) {
                                      var variableName = (javascriptGenerator as any).nameDB_.getName(
                                        block.getFieldValue('VAR'),
                                        'VARIABLE'
                                      );
                                      
                                        var value = 'NAN';
                                        var entity = '';
                                        var entityVariable = '';
                                      if(variableName.includes('localVariable') || variableName.includes('globalVariable')) {
                                        variableName = variableName.replace('.data' , '');
                                        entity = variableName.split('$')[0];
                                        if(entity == 'localVariable')
                                        entity = 'local_variable';
                                        else if(entity == 'globalVariable')
                                        entity = 'global_variable';
                                        else
                                        alert('problem in blockly function customBlockForPushToEntityList different entity that localVariable or globalVariable have been selected');
                              
                                        entityVariable = variableName.split('$')[1]; 
                                        if(entity && entity !== '' && entityVariable && entityVariable !== '')
                                        value = '{ entity:\'' + entity+ '\', entityVariable: \'' + entityVariable+ '\' }'
                                         else 
                                        value = 'NAN';
                                      } else {
                                        if(variableName.includes('$$')) {
                                         entity = variableName.split('$$')[0];
                                         entityVariable = variableName.split('$$')[1]; 
                                        } else {
                              
                                         entity = variableName.split('$')[0];
                                         entityVariable = variableName.split('$')[1]; 
                                        }
                                        if(entity && entity !== '' && entityVariable && entityVariable !== '')
                                        value = '{ entity:\'' + entity+ '\', entityVariable: \'' + entityVariable+ '\' }'
                                         else 
                                        value = 'NAN';
                                      }
                                      
                              
                                          var code = '';
                                
                                    if( value !== 'NAN')
                                     var code = '((this.multiDataManagementService.getVariableByMultiData(' + value + ' , multiDataIndex)).data?.length ?? 0)';
                                      return [code, (javascriptGenerator as any).ORDER_ATOMIC];;
                                    };
                                    class NonEditableFieldVariable extends Blockly.FieldVariable {
                                      constructor(
                                        variableName: any,
                                        validator: any,
                                        variableTypes: any,
                                        defaultType: any
                                      ) {
                                        super(variableName, validator, variableTypes, defaultType);
                                      }
                                
                                      // Override the showEditor_ method to disable editing
                                      override showEditor_() {
            // click the dropdown → open Atlas (same action as the swap-variable button)
            AtlasFieldBridge.open && AtlasFieldBridge.open((this as any).getSourceBlock());
          }
                                    }
                                  } ,
                                    customBlockForDeleteFromEntityList() {
                                      // Clickable ⓘ help (tooltips don't render in this editor): click shows the index legend.
                                      class DeleteHelpField extends Blockly.FieldTextInput {
                                        legendText: any;
                                        override showEditor_() { try { (window as any).alert((this as any).legendText || ''); } catch { /* no-op */ } }
                                      }
                                      const makeDeleteHelp = (): any => {
                                        const f: any = new DeleteHelpField('ⓘ');
                                        f.legendText = 'Delete position:\n• in-range index → deletes that item\n• empty or out-of-range → deletes the last item';
                                        return f;
                                      };
                                      Blockly.Blocks['delete_from_entity_list'] = {
                                        init: function () {
                                          this.appendValueInput('ARRAY_INPUT')
                                            .appendField('delete from entity list')
                                            .setCheck('Array');


                                          this.appendValueInput('INDEX').setCheck('Number').appendField('at index (optional)').appendField(makeDeleteHelp(), 'IDX_INFO');
                                  
                                          this.setPreviousStatement(true, null);
                                          this.setNextStatement(true, null);
                                          this.setColour('#800000');
                                          this.setTooltip('Delete item from entity list at specified index');
                                          this.setHelpUrl('');
                                        },
                                      };
                                  
                                      (javascriptGenerator as any).forBlock['delete_from_entity_list'] = function (
                                        block: any
                                      ) {
                                        var variableName = (javascriptGenerator as any).valueToCode(
                                          block,
                                          'ARRAY_INPUT',
                                          (javascriptGenerator as any).ORDER_MEMBER
                                        ) || '[]';
                                  
                                        var index =
                                          (javascriptGenerator as any).valueToCode(
                                            block,
                                            'INDEX',
                                            (javascriptGenerator as any).ORDER_ASSIGNMENT
                                          ); // '' when the socket is empty
                                  
                                        var value = 'NAN';
                                        var entity = '';
                                        var entityVariable = '';
                                        console.log('variableName', variableName);
                                        variableName = variableName.replaceAll('localVariable', 'local_variable');
                                        variableName = variableName.replaceAll('globalVariable', 'global_variable');
                                        variableName = variableName.replaceAll('.data' , '');
                                        if(variableName.includes('$$')) {
                                          entity = variableName.split('$$')[0];
                                          entityVariable = variableName.split('$$')[1];
                                        } else if(variableName.includes('$')) {
                                          entity = variableName.split('$')[0];
                                          entityVariable = variableName.split('$')[1];  
                                        }
                                          if(entity && entity !== '' && entityVariable && entityVariable !== '')
                                            // index: in-range → that item; empty / out-of-range / weird → the last item
                                            value = ' var returnedData = this.multiDataManagementService.getVariableByMultiData({ entity:\'' + entity+ '\', entityVariable: \'' + entityVariable+ '\' } , []); if(returnedData.data && returnedData.data.length) { var __i = Math.floor(Number(' + (index || 'NaN') + ')); if(!isFinite(__i) || __i < 0 || __i >= returnedData.data.length) __i = returnedData.data.length - 1; returnedData.data.splice(__i, 1); } '
                                          else
                                            value = 'NAN';
                                  
                                        var code = '';
                                        if( value !== 'NAN')
                                          code = value;
                                  
                                        code += `\nthis.reinitializeComponantsFlag = true;\n this.scrollPositionsFlag = true; \n`;
                                        // console.log('code for delete from entity list', code);
                                        return code;
                                      };
                                    } ,

};